var XHTML_1_0_Strict_Module_Factory = function () {
  var XHTML_1_0_Strict = {
    n: 'XHTML_1_0_Strict',
    dens: 'http:\/\/www.w3.org\/1999\/xhtml',
    tis: [{
        ln: 'Pre',
        tn: null,
        bti: '.PreContent',
        ps: [{
            n: 'space',
            an: {
              lp: 'space',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Optgroup',
        tn: null,
        ps: [{
            n: 'option',
            rq: true,
            col: true,
            ti: '.Option'
          }, {
            n: 'disabled',
            an: {
              lp: 'disabled'
            },
            t: 'a'
          }, {
            n: 'label',
            rq: true,
            an: {
              lp: 'label'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'H5',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Textarea',
        tn: null,
        ps: [{
            n: 'content',
            t: 'v'
          }, {
            n: 'name',
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'rows',
            rq: true,
            ti: 'NonNegativeInteger',
            an: {
              lp: 'rows'
            },
            t: 'a'
          }, {
            n: 'cols',
            rq: true,
            ti: 'NonNegativeInteger',
            an: {
              lp: 'cols'
            },
            t: 'a'
          }, {
            n: 'disabled',
            an: {
              lp: 'disabled'
            },
            t: 'a'
          }, {
            n: 'readonly',
            an: {
              lp: 'readonly'
            },
            t: 'a'
          }, {
            n: 'onselect',
            an: {
              lp: 'onselect'
            },
            t: 'a'
          }, {
            n: 'onchange',
            an: {
              lp: 'onchange'
            },
            t: 'a'
          }, {
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Ins',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'cite',
            an: {
              lp: 'cite'
            },
            t: 'a'
          }, {
            n: 'datetime',
            ti: 'DateTime',
            an: {
              lp: 'datetime'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Tfoot',
        tn: null,
        ps: [{
            n: 'tr',
            rq: true,
            col: true,
            ti: '.Tr'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }]
      }, {
        ln: 'Dd',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Th',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'abbr',
            an: {
              lp: 'abbr'
            },
            t: 'a'
          }, {
            n: 'axis',
            ti: 'AnySimpleType',
            an: {
              lp: 'axis'
            },
            t: 'a'
          }, {
            n: 'headers',
            ti: 'IDREFS',
            an: {
              lp: 'headers'
            },
            t: 'a'
          }, {
            n: 'scope',
            ti: 'Token',
            an: {
              lp: 'scope'
            },
            t: 'a'
          }, {
            n: 'rowspan',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'rowspan'
            },
            t: 'a'
          }, {
            n: 'colspan',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'colspan'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }]
      }, {
        ln: 'I',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Title',
        tn: null,
        ps: [{
            n: 'content',
            t: 'v'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }]
      }, {
        ln: 'FormContent',
        tn: 'form.content',
        ps: [{
            n: 'pOrH1OrH2',
            mno: 0,
            col: true,
            etis: [{
                en: 'p',
                ti: '.P'
              }, {
                en: 'h1',
                ti: '.H1'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'fieldset',
                ti: '.Fieldset'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'script',
                ti: '.Script'
              }],
            t: 'es'
          }]
      }, {
        ln: 'Sub',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Span',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Html',
        tn: null,
        ps: [{
            n: 'head',
            rq: true,
            ti: '.Head'
          }, {
            n: 'body',
            rq: true,
            ti: '.Body'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }]
      }, {
        ln: 'Tr',
        tn: null,
        ps: [{
            n: 'thOrTd',
            rq: true,
            col: true,
            etis: [{
                en: 'th',
                ti: '.Th'
              }, {
                en: 'td',
                ti: '.Td'
              }],
            t: 'es'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }]
      }, {
        ln: 'H6',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Em',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Input',
        tn: null,
        ps: [{
            n: 'type',
            ti: 'Token',
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'name',
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'value',
            ti: 'AnySimpleType',
            an: {
              lp: 'value'
            },
            t: 'a'
          }, {
            n: 'checked',
            an: {
              lp: 'checked'
            },
            t: 'a'
          }, {
            n: 'disabled',
            an: {
              lp: 'disabled'
            },
            t: 'a'
          }, {
            n: 'readonly',
            an: {
              lp: 'readonly'
            },
            t: 'a'
          }, {
            n: 'size',
            ti: 'AnySimpleType',
            an: {
              lp: 'size'
            },
            t: 'a'
          }, {
            n: 'maxlength',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'maxlength'
            },
            t: 'a'
          }, {
            n: 'src',
            an: {
              lp: 'src'
            },
            t: 'a'
          }, {
            n: 'alt',
            ti: 'AnySimpleType',
            an: {
              lp: 'alt'
            },
            t: 'a'
          }, {
            n: 'usemap',
            an: {
              lp: 'usemap'
            },
            t: 'a'
          }, {
            n: 'onselect',
            an: {
              lp: 'onselect'
            },
            t: 'a'
          }, {
            n: 'onchange',
            an: {
              lp: 'onchange'
            },
            t: 'a'
          }, {
            n: 'accept',
            an: {
              lp: 'accept'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }]
      }, {
        ln: 'Hr',
        tn: null,
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Img',
        tn: null,
        ps: [{
            n: 'src',
            rq: true,
            an: {
              lp: 'src'
            },
            t: 'a'
          }, {
            n: 'alt',
            rq: true,
            an: {
              lp: 'alt'
            },
            t: 'a'
          }, {
            n: 'longdesc',
            an: {
              lp: 'longdesc'
            },
            t: 'a'
          }, {
            n: 'height',
            an: {
              lp: 'height'
            },
            t: 'a'
          }, {
            n: 'width',
            an: {
              lp: 'width'
            },
            t: 'a'
          }, {
            n: 'usemap',
            an: {
              lp: 'usemap'
            },
            t: 'a'
          }, {
            n: 'ismap',
            an: {
              lp: 'ismap'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Dl',
        tn: null,
        ps: [{
            n: 'dtOrDd',
            rq: true,
            col: true,
            etis: [{
                en: 'dt',
                ti: '.Dt'
              }, {
                en: 'dd',
                ti: '.Dd'
              }],
            t: 'es'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Sup',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Label',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: '_for',
            ti: 'IDREF',
            an: {
              lp: 'for'
            },
            t: 'a'
          }, {
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Ol',
        tn: null,
        ps: [{
            n: 'li',
            rq: true,
            col: true,
            ti: '.Li'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Noscript',
        tn: null,
        bti: '.Block',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'H2',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Var',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Body',
        tn: null,
        bti: '.Block',
        ps: [{
            n: 'onload',
            an: {
              lp: 'onload'
            },
            t: 'a'
          }, {
            n: 'onunload',
            an: {
              lp: 'onunload'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'AContent',
        tn: 'a.content',
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'label',
                ti: '.Label'
              }, {
                en: 'object',
                ti: '.Object'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'textarea',
                ti: '.Textarea'
              }, {
                en: 'select',
                ti: '.Select'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'input',
                ti: '.Input'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'img',
                ti: '.Img'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'button',
                ti: '.Button'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'Blockquote',
        tn: null,
        bti: '.Block',
        ps: [{
            n: 'cite',
            an: {
              lp: 'cite'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Thead',
        tn: null,
        ps: [{
            n: 'tr',
            rq: true,
            col: true,
            ti: '.Tr'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }]
      }, {
        ln: 'Colgroup',
        tn: null,
        ps: [{
            n: 'col',
            mno: 0,
            col: true,
            ti: '.Col'
          }, {
            n: 'span',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'span'
            },
            t: 'a'
          }, {
            n: 'width',
            an: {
              lp: 'width'
            },
            t: 'a'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'H4',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Meta',
        tn: null,
        ps: [{
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'httpEquiv',
            ti: 'AnySimpleType',
            an: {
              lp: 'http-equiv'
            },
            t: 'a'
          }, {
            n: 'name',
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'content',
            rq: true,
            ti: 'AnySimpleType',
            an: {
              lp: 'content'
            },
            t: 'a'
          }, {
            n: 'scheme',
            ti: 'AnySimpleType',
            an: {
              lp: 'scheme'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }]
      }, {
        ln: 'Bdo',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            rq: true,
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'PreContent',
        tn: 'pre.content',
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'label',
                ti: '.Label'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'textarea',
                ti: '.Textarea'
              }, {
                en: 'select',
                ti: '.Select'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'input',
                ti: '.Input'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'a',
                ti: '.A'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'button',
                ti: '.Button'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'Big',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Option',
        tn: null,
        ps: [{
            n: 'content',
            t: 'v'
          }, {
            n: 'selected',
            an: {
              lp: 'selected'
            },
            t: 'a'
          }, {
            n: 'disabled',
            an: {
              lp: 'disabled'
            },
            t: 'a'
          }, {
            n: 'label',
            an: {
              lp: 'label'
            },
            t: 'a'
          }, {
            n: 'value',
            ti: 'AnySimpleType',
            an: {
              lp: 'value'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'P',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Cite',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Area',
        tn: null,
        ps: [{
            n: 'shape',
            ti: 'Token',
            an: {
              lp: 'shape'
            },
            t: 'a'
          }, {
            n: 'coords',
            an: {
              lp: 'coords'
            },
            t: 'a'
          }, {
            n: 'href',
            an: {
              lp: 'href'
            },
            t: 'a'
          }, {
            n: 'nohref',
            an: {
              lp: 'nohref'
            },
            t: 'a'
          }, {
            n: 'alt',
            rq: true,
            an: {
              lp: 'alt'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }]
      }, {
        ln: 'Td',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'abbr',
            an: {
              lp: 'abbr'
            },
            t: 'a'
          }, {
            n: 'axis',
            ti: 'AnySimpleType',
            an: {
              lp: 'axis'
            },
            t: 'a'
          }, {
            n: 'headers',
            ti: 'IDREFS',
            an: {
              lp: 'headers'
            },
            t: 'a'
          }, {
            n: 'scope',
            ti: 'Token',
            an: {
              lp: 'scope'
            },
            t: 'a'
          }, {
            n: 'rowspan',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'rowspan'
            },
            t: 'a'
          }, {
            n: 'colspan',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'colspan'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }]
      }, {
        ln: 'Br',
        tn: null,
        ps: [{
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }]
      }, {
        ln: 'Tbody',
        tn: null,
        ps: [{
            n: 'tr',
            rq: true,
            col: true,
            ti: '.Tr'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Map',
        tn: null,
        ps: [{
            n: 'pOrH1OrH2',
            rq: true,
            col: true,
            etis: [{
                en: 'p',
                ti: '.P'
              }, {
                en: 'h1',
                ti: '.H1'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'fieldset',
                ti: '.Fieldset'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'form',
                ti: '.Form'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'script',
                ti: '.Script'
              }],
            t: 'es'
          }, {
            n: 'area',
            rq: true,
            col: true,
            ti: '.Area'
          }, {
            n: 'id',
            rq: true,
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: 'AnySimpleType',
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'name',
            ti: 'NMToken',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Script',
        tn: null,
        ps: [{
            n: 'content',
            t: 'v'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'charset',
            an: {
              lp: 'charset'
            },
            t: 'a'
          }, {
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'src',
            an: {
              lp: 'src'
            },
            t: 'a'
          }, {
            n: 'defer',
            an: {
              lp: 'defer'
            },
            t: 'a'
          }, {
            n: 'space',
            an: {
              lp: 'space',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }]
      }, {
        ln: 'Flow',
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'object',
                ti: '.Object'
              }, {
                en: 'textarea',
                ti: '.Textarea'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'p',
                ti: '.P'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'input',
                ti: '.Input'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'fieldset',
                ti: '.Fieldset'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'label',
                ti: '.Label'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'select',
                ti: '.Select'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'a',
                ti: '.A'
              }, {
                en: 'img',
                ti: '.Img'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'form',
                ti: '.Form'
              }, {
                en: 'button',
                ti: '.Button'
              }, {
                en: 'h1',
                ti: '.H1'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'Kbd',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Abbr',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Dt',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Base',
        tn: null,
        ps: [{
            n: 'href',
            rq: true,
            an: {
              lp: 'href'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'H3',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Block',
        ps: [{
            n: 'pOrH1OrH2',
            mno: 0,
            col: true,
            etis: [{
                en: 'p',
                ti: '.P'
              }, {
                en: 'h1',
                ti: '.H1'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'fieldset',
                ti: '.Fieldset'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'form',
                ti: '.Form'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'script',
                ti: '.Script'
              }],
            t: 'es'
          }]
      }, {
        ln: 'Legend',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Small',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Table',
        tn: null,
        ps: [{
            n: 'caption',
            ti: '.Caption'
          }, {
            n: 'col',
            mno: 0,
            col: true,
            ti: '.Col'
          }, {
            n: 'colgroup',
            mno: 0,
            col: true,
            ti: '.Colgroup'
          }, {
            n: 'thead',
            ti: '.Thead'
          }, {
            n: 'tfoot',
            ti: '.Tfoot'
          }, {
            n: 'tbody',
            rq: true,
            col: true,
            ti: '.Tbody'
          }, {
            n: 'tr',
            rq: true,
            col: true,
            ti: '.Tr'
          }, {
            n: 'summary',
            an: {
              lp: 'summary'
            },
            t: 'a'
          }, {
            n: 'width',
            an: {
              lp: 'width'
            },
            t: 'a'
          }, {
            n: 'border',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'border'
            },
            t: 'a'
          }, {
            n: 'frame',
            ti: 'Token',
            an: {
              lp: 'frame'
            },
            t: 'a'
          }, {
            n: 'rules',
            ti: 'Token',
            an: {
              lp: 'rules'
            },
            t: 'a'
          }, {
            n: 'cellspacing',
            an: {
              lp: 'cellspacing'
            },
            t: 'a'
          }, {
            n: 'cellpadding',
            an: {
              lp: 'cellpadding'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Fieldset',
        tn: null,
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'object',
                ti: '.Object'
              }, {
                en: 'textarea',
                ti: '.Textarea'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'legend',
                ti: '.Legend'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'p',
                ti: '.P'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'input',
                ti: '.Input'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'fieldset',
                ti: '.Fieldset'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'label',
                ti: '.Label'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'select',
                ti: '.Select'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'a',
                ti: '.A'
              }, {
                en: 'img',
                ti: '.Img'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'form',
                ti: '.Form'
              }, {
                en: 'button',
                ti: '.Button'
              }, {
                en: 'h1',
                ti: '.H1'
              }],
            t: 'ers'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Caption',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'H1',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Style',
        tn: null,
        ps: [{
            n: 'content',
            t: 'v'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'type',
            rq: true,
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'media',
            an: {
              lp: 'media'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'space',
            an: {
              lp: 'space',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }]
      }, {
        ln: 'Dfn',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Strong',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Q',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'cite',
            an: {
              lp: 'cite'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Div',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Del',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'cite',
            an: {
              lp: 'cite'
            },
            t: 'a'
          }, {
            n: 'datetime',
            ti: 'DateTime',
            an: {
              lp: 'datetime'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Tt',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'ButtonContent',
        tn: 'button.content',
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'object',
                ti: '.Object'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'p',
                ti: '.P'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'img',
                ti: '.Img'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'h1',
                ti: '.H1'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'Form',
        tn: null,
        bti: '.FormContent',
        ps: [{
            n: 'action',
            rq: true,
            an: {
              lp: 'action'
            },
            t: 'a'
          }, {
            n: 'method',
            an: {
              lp: 'method'
            },
            t: 'a'
          }, {
            n: 'enctype',
            an: {
              lp: 'enctype'
            },
            t: 'a'
          }, {
            n: 'onsubmit',
            an: {
              lp: 'onsubmit'
            },
            t: 'a'
          }, {
            n: 'onreset',
            an: {
              lp: 'onreset'
            },
            t: 'a'
          }, {
            n: 'accept',
            an: {
              lp: 'accept'
            },
            t: 'a'
          }, {
            n: 'acceptCharset',
            an: {
              lp: 'accept-charset'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Acronym',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Head',
        tn: null,
        ps: [{
            n: 'content',
            rq: true,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'object',
                ti: '.Object'
              }, {
                en: 'base',
                ti: '.Base'
              }, {
                en: 'link',
                ti: '.Link'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'meta',
                ti: '.Meta'
              }, {
                en: 'title',
                ti: '.Title'
              }, {
                en: 'style',
                ti: '.Style'
              }],
            t: 'ers'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'profile',
            an: {
              lp: 'profile'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }]
      }, {
        ln: 'Link',
        tn: null,
        ps: [{
            n: 'charset',
            an: {
              lp: 'charset'
            },
            t: 'a'
          }, {
            n: 'href',
            an: {
              lp: 'href'
            },
            t: 'a'
          }, {
            n: 'hreflang',
            ti: 'Language',
            an: {
              lp: 'hreflang'
            },
            t: 'a'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'rel',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'rel'
            },
            t: 'a'
          }, {
            n: 'rev',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'rev'
            },
            t: 'a'
          }, {
            n: 'media',
            an: {
              lp: 'media'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Inline',
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'label',
                ti: '.Label'
              }, {
                en: 'object',
                ti: '.Object'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'textarea',
                ti: '.Textarea'
              }, {
                en: 'select',
                ti: '.Select'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'input',
                ti: '.Input'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'a',
                ti: '.A'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'img',
                ti: '.Img'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'button',
                ti: '.Button'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'Param',
        tn: null,
        ps: [{
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'name',
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'value',
            ti: 'AnySimpleType',
            an: {
              lp: 'value'
            },
            t: 'a'
          }, {
            n: 'valuetype',
            an: {
              lp: 'valuetype'
            },
            t: 'a'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }]
      }, {
        ln: 'Address',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Li',
        tn: null,
        bti: '.Flow',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Select',
        tn: null,
        ps: [{
            n: 'optgroupOrOption',
            rq: true,
            col: true,
            etis: [{
                en: 'optgroup',
                ti: '.Optgroup'
              }, {
                en: 'option',
                ti: '.Option'
              }],
            t: 'es'
          }, {
            n: 'name',
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'size',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'size'
            },
            t: 'a'
          }, {
            n: 'multiple',
            an: {
              lp: 'multiple'
            },
            t: 'a'
          }, {
            n: 'disabled',
            an: {
              lp: 'disabled'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }, {
            n: 'onchange',
            an: {
              lp: 'onchange'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Ul',
        tn: null,
        ps: [{
            n: 'li',
            rq: true,
            col: true,
            ti: '.Li'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Code',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Col',
        tn: null,
        ps: [{
            n: 'span',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'span'
            },
            t: 'a'
          }, {
            n: 'width',
            an: {
              lp: 'width'
            },
            t: 'a'
          }, {
            n: 'align',
            an: {
              lp: 'align'
            },
            t: 'a'
          }, {
            n: '_char',
            an: {
              lp: 'char'
            },
            t: 'a'
          }, {
            n: 'charoff',
            an: {
              lp: 'charoff'
            },
            t: 'a'
          }, {
            n: 'valign',
            an: {
              lp: 'valign'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Button',
        tn: null,
        bti: '.ButtonContent',
        ps: [{
            n: 'name',
            ti: 'AnySimpleType',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'value',
            ti: 'AnySimpleType',
            an: {
              lp: 'value'
            },
            t: 'a'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'disabled',
            an: {
              lp: 'disabled'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }, {
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }]
      }, {
        ln: 'A',
        tn: null,
        bti: '.AContent',
        ps: [{
            n: 'charset',
            an: {
              lp: 'charset'
            },
            t: 'a'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'name',
            ti: 'NMToken',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'href',
            an: {
              lp: 'href'
            },
            t: 'a'
          }, {
            n: 'hreflang',
            ti: 'Language',
            an: {
              lp: 'hreflang'
            },
            t: 'a'
          }, {
            n: 'rel',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'rel'
            },
            t: 'a'
          }, {
            n: 'rev',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'rev'
            },
            t: 'a'
          }, {
            n: 'shape',
            ti: 'Token',
            an: {
              lp: 'shape'
            },
            t: 'a'
          }, {
            n: 'coords',
            an: {
              lp: 'coords'
            },
            t: 'a'
          }, {
            n: 'accesskey',
            an: {
              lp: 'accesskey'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'onfocus',
            an: {
              lp: 'onfocus'
            },
            t: 'a'
          }, {
            n: 'onblur',
            an: {
              lp: 'onblur'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'B',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Object',
        tn: null,
        ps: [{
            n: 'content',
            col: true,
            dom: false,
            etis: [{
                en: 'cite',
                ti: '.Cite'
              }, {
                en: 'sup',
                ti: '.Sup'
              }, {
                en: 'object',
                ti: '.Object'
              }, {
                en: 'textarea',
                ti: '.Textarea'
              }, {
                en: 'ul',
                ti: '.Ul'
              }, {
                en: 'br',
                ti: '.Br'
              }, {
                en: 'abbr',
                ti: '.Abbr'
              }, {
                en: 'map',
                ti: '.Map'
              }, {
                en: 'dfn',
                ti: '.Dfn'
              }, {
                en: 'h2',
                ti: '.H2'
              }, {
                en: 'p',
                ti: '.P'
              }, {
                en: 'h5',
                ti: '.H5'
              }, {
                en: 'big',
                ti: '.Big'
              }, {
                en: 'kbd',
                ti: '.Kbd'
              }, {
                en: 'em',
                ti: '.Em'
              }, {
                en: 'h6',
                ti: '.H6'
              }, {
                en: 'h3',
                ti: '.H3'
              }, {
                en: 'address',
                ti: '.Address'
              }, {
                en: 'script',
                ti: '.Script'
              }, {
                en: 'input',
                ti: '.Input'
              }, {
                en: 'del',
                ti: '.Del'
              }, {
                en: 'fieldset',
                ti: '.Fieldset'
              }, {
                en: 'blockquote',
                ti: '.Blockquote'
              }, {
                en: 'acronym',
                ti: '.Acronym'
              }, {
                en: 'span',
                ti: '.Span'
              }, {
                en: 'i',
                ti: '.I'
              }, {
                en: 'sub',
                ti: '.Sub'
              }, {
                en: 'strong',
                ti: '.Strong'
              }, {
                en: 'h4',
                ti: '.H4'
              }, {
                en: 'pre',
                ti: '.Pre'
              }, {
                en: 'hr',
                ti: '.Hr'
              }, {
                en: 'label',
                ti: '.Label'
              }, {
                en: 'table',
                ti: '.Table'
              }, {
                en: 'var',
                ti: '.Var'
              }, {
                en: 'select',
                ti: '.Select'
              }, {
                en: 'param',
                ti: '.Param'
              }, {
                en: 'samp',
                ti: '.Samp'
              }, {
                en: 'dl',
                ti: '.Dl'
              }, {
                en: 'div',
                ti: '.Div'
              }, {
                en: 'q',
                ti: '.Q'
              }, {
                en: 'bdo',
                ti: '.Bdo'
              }, {
                en: 'tt',
                ti: '.Tt'
              }, {
                en: 'ol',
                ti: '.Ol'
              }, {
                en: 'code',
                ti: '.Code'
              }, {
                en: 'noscript',
                ti: '.Noscript'
              }, {
                en: 'ins',
                ti: '.Ins'
              }, {
                en: 'a',
                ti: '.A'
              }, {
                en: 'img',
                ti: '.Img'
              }, {
                en: 'small',
                ti: '.Small'
              }, {
                en: 'b',
                ti: '.B'
              }, {
                en: 'form',
                ti: '.Form'
              }, {
                en: 'button',
                ti: '.Button'
              }, {
                en: 'h1',
                ti: '.H1'
              }],
            t: 'ers'
          }, {
            n: 'declare',
            an: {
              lp: 'declare'
            },
            t: 'a'
          }, {
            n: 'classid',
            an: {
              lp: 'classid'
            },
            t: 'a'
          }, {
            n: 'codebase',
            an: {
              lp: 'codebase'
            },
            t: 'a'
          }, {
            n: 'data',
            an: {
              lp: 'data'
            },
            t: 'a'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }, {
            n: 'codetype',
            an: {
              lp: 'codetype'
            },
            t: 'a'
          }, {
            n: 'archive',
            an: {
              lp: 'archive'
            },
            t: 'a'
          }, {
            n: 'standby',
            an: {
              lp: 'standby'
            },
            t: 'a'
          }, {
            n: 'height',
            an: {
              lp: 'height'
            },
            t: 'a'
          }, {
            n: 'width',
            an: {
              lp: 'width'
            },
            t: 'a'
          }, {
            n: 'usemap',
            an: {
              lp: 'usemap'
            },
            t: 'a'
          }, {
            n: 'name',
            ti: 'NMToken',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'tabindex',
            ti: 'NonNegativeInteger',
            an: {
              lp: 'tabindex'
            },
            t: 'a'
          }, {
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        ln: 'Samp',
        tn: null,
        bti: '.Inline',
        ps: [{
            n: 'lang',
            ti: 'Language',
            an: {
              lp: 'lang'
            },
            t: 'a'
          }, {
            n: 'xmlLang',
            an: {
              lp: 'lang',
              ns: 'http:\/\/www.w3.org\/XML\/1998\/namespace'
            },
            t: 'a'
          }, {
            n: 'dir',
            an: {
              lp: 'dir'
            },
            t: 'a'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'clazz',
            ti: {
              t: 'l',
              bti: 'NMTokens'
            },
            an: {
              lp: 'class'
            },
            t: 'a'
          }, {
            n: 'style',
            an: {
              lp: 'style'
            },
            t: 'a'
          }, {
            n: 'title',
            an: {
              lp: 'title'
            },
            t: 'a'
          }, {
            n: 'onclick',
            an: {
              lp: 'onclick'
            },
            t: 'a'
          }, {
            n: 'ondblclick',
            an: {
              lp: 'ondblclick'
            },
            t: 'a'
          }, {
            n: 'onmousedown',
            an: {
              lp: 'onmousedown'
            },
            t: 'a'
          }, {
            n: 'onmouseup',
            an: {
              lp: 'onmouseup'
            },
            t: 'a'
          }, {
            n: 'onmouseover',
            an: {
              lp: 'onmouseover'
            },
            t: 'a'
          }, {
            n: 'onmousemove',
            an: {
              lp: 'onmousemove'
            },
            t: 'a'
          }, {
            n: 'onmouseout',
            an: {
              lp: 'onmouseout'
            },
            t: 'a'
          }, {
            n: 'onkeypress',
            an: {
              lp: 'onkeypress'
            },
            t: 'a'
          }, {
            n: 'onkeydown',
            an: {
              lp: 'onkeydown'
            },
            t: 'a'
          }, {
            n: 'onkeyup',
            an: {
              lp: 'onkeyup'
            },
            t: 'a'
          }]
      }, {
        t: 'enum',
        ln: 'TRules',
        bti: 'Token',
        vs: ['none', 'groups', 'rows', 'cols', 'all']
      }, {
        t: 'enum',
        ln: 'TFrame',
        bti: 'Token',
        vs: ['void', 'above', 'below', 'hsides', 'lhs', 'rhs', 'vsides', 'box', 'border']
      }, {
        t: 'enum',
        ln: 'InputType',
        bti: 'Token',
        vs: ['text', 'password', 'checkbox', 'radio', 'submit', 'reset', 'file', 'hidden', 'image', 'button']
      }, {
        t: 'enum',
        ln: 'Shape',
        bti: 'Token',
        vs: ['rect', 'circle', 'poly', 'default']
      }, {
        t: 'enum',
        ln: 'Scope',
        bti: 'Token',
        vs: ['row', 'col', 'rowgroup', 'colgroup']
      }],
    eis: [{
        en: 'tr',
        ti: '.Tr'
      }, {
        en: 'address',
        ti: '.Address'
      }, {
        en: 'i',
        ti: '.I'
      }, {
        en: 'h3',
        ti: '.H3'
      }, {
        en: 'area',
        ti: '.Area'
      }, {
        en: 'hr',
        ti: '.Hr'
      }, {
        en: 'h2',
        ti: '.H2'
      }, {
        en: 'em',
        ti: '.Em'
      }, {
        en: 'dfn',
        ti: '.Dfn'
      }, {
        en: 'kbd',
        ti: '.Kbd'
      }, {
        en: 'label',
        ti: '.Label'
      }, {
        en: 'strong',
        ti: '.Strong'
      }, {
        en: 'td',
        ti: '.Td'
      }, {
        en: 'link',
        ti: '.Link'
      }, {
        en: 'var',
        ti: '.Var'
      }, {
        en: 'cite',
        ti: '.Cite'
      }, {
        en: 'q',
        ti: '.Q'
      }, {
        en: 'object',
        ti: '.Object'
      }, {
        en: 'code',
        ti: '.Code'
      }, {
        en: 'thead',
        ti: '.Thead'
      }, {
        en: 'colgroup',
        ti: '.Colgroup'
      }, {
        en: 'span',
        ti: '.Span'
      }, {
        en: 'blockquote',
        ti: '.Blockquote'
      }, {
        en: 'title',
        ti: '.Title'
      }, {
        en: 'col',
        ti: '.Col'
      }, {
        en: 'head',
        ti: '.Head'
      }, {
        en: 'a',
        ti: '.A'
      }, {
        en: 'b',
        ti: '.B'
      }, {
        en: 'samp',
        ti: '.Samp'
      }, {
        en: 'select',
        ti: '.Select'
      }, {
        en: 'li',
        ti: '.Li'
      }, {
        en: 'h6',
        ti: '.H6'
      }, {
        en: 'map',
        ti: '.Map'
      }, {
        en: 'img',
        ti: '.Img'
      }, {
        en: 'dl',
        ti: '.Dl'
      }, {
        en: 'button',
        ti: '.Button'
      }, {
        en: 'optgroup',
        ti: '.Optgroup'
      }, {
        en: 'meta',
        ti: '.Meta'
      }, {
        en: 'ol',
        ti: '.Ol'
      }, {
        en: 'caption',
        ti: '.Caption'
      }, {
        en: 'tfoot',
        ti: '.Tfoot'
      }, {
        en: 'h1',
        ti: '.H1'
      }, {
        en: 'dt',
        ti: '.Dt'
      }, {
        en: 'base',
        ti: '.Base'
      }, {
        en: 'tbody',
        ti: '.Tbody'
      }, {
        en: 'form',
        ti: '.Form'
      }, {
        en: 'html',
        ti: '.Html'
      }, {
        en: 'bdo',
        ti: '.Bdo'
      }, {
        en: 'pre',
        ti: '.Pre'
      }, {
        en: 'big',
        ti: '.Big'
      }, {
        en: 'small',
        ti: '.Small'
      }, {
        en: 'sub',
        ti: '.Sub'
      }, {
        en: 'br',
        ti: '.Br'
      }, {
        en: 'sup',
        ti: '.Sup'
      }, {
        en: 'input',
        ti: '.Input'
      }, {
        en: 'script',
        ti: '.Script'
      }, {
        en: 'h4',
        ti: '.H4'
      }, {
        en: 'h5',
        ti: '.H5'
      }, {
        en: 'del',
        ti: '.Del'
      }, {
        en: 'option',
        ti: '.Option'
      }, {
        en: 'ul',
        ti: '.Ul'
      }, {
        en: 'noscript',
        ti: '.Noscript'
      }, {
        en: 'style',
        ti: '.Style'
      }, {
        en: 'dd',
        ti: '.Dd'
      }, {
        en: 'table',
        ti: '.Table'
      }, {
        en: 'textarea',
        ti: '.Textarea'
      }, {
        en: 'p',
        ti: '.P'
      }, {
        en: 'div',
        ti: '.Div'
      }, {
        en: 'acronym',
        ti: '.Acronym'
      }, {
        en: 'tt',
        ti: '.Tt'
      }, {
        en: 'body',
        ti: '.Body'
      }, {
        en: 'legend',
        ti: '.Legend'
      }, {
        en: 'abbr',
        ti: '.Abbr'
      }, {
        en: 'ins',
        ti: '.Ins'
      }, {
        en: 'param',
        ti: '.Param'
      }, {
        en: 'th',
        ti: '.Th'
      }, {
        en: 'fieldset',
        ti: '.Fieldset'
      }]
  };
  return {
    XHTML_1_0_Strict: XHTML_1_0_Strict
  };
};
if (typeof define === 'function' && define.amd) {
  define([], XHTML_1_0_Strict_Module_Factory);
}
else {
  var XHTML_1_0_Strict_Module = XHTML_1_0_Strict_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.XHTML_1_0_Strict = XHTML_1_0_Strict_Module.XHTML_1_0_Strict;
  }
  else {
    var XHTML_1_0_Strict = XHTML_1_0_Strict_Module.XHTML_1_0_Strict;
  }
}